module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.accountPermissions) ? _c('table', {
    staticClass: "table table-striped"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._v(_vm._s(_vm.$t('account.permission')))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.accountPermissions), function(accountPermission) {
    return _c('account-permissions-row', {
      key: accountPermission,
      attrs: {
        "accountPermission": accountPermission
      }
    })
  })), _vm._v(" "), _c('tfoot', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.accountPermissions.length >= 10),
      expression: "accountPermissions.length >= 10"
    }]
  }, [_c('tr', [_c('th', {
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._v(_vm._s(_vm.$t('account.permission')))])])])], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1b51fe81"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/account/AccountPermissionsTable.vue
// module id = 479
// module chunks = 0